import React from 'react';
import ReactDOM from 'react-dom/client';
import { Toaster } from 'react-hot-toast';
import { Router } from './router.tsx';
import { CartProvider } from './store/cart.tsx';
import { logErrorToServer } from './utils/logger.js';
import { captureException, initSentry } from './utils/sentry.js';
import './styles/index.css';

// 初始化 Sentry（必須在所有其他初始化之前）
initSentry();

// 在 ReactDOM.createRoot 之前初始化全域錯誤監聽器

// 1. 捕捉未被 Catch 的 Promise 錯誤（如 API 失敗）
window.addEventListener('unhandledrejection', event => {
  const error =
    event.reason instanceof Error
      ? event.reason
      : new Error(`Unhandled Rejection: ${String(event.reason)}`);

  // 添加更多上下文信息
  const errorContext: Record<string, unknown> = {
    type: 'unhandledrejection',
    reason: String(event.reason),
    timestamp: new Date().toISOString(),
  };

  // 如果是 API 錯誤，添加更多信息
  if (event.reason && typeof event.reason === 'object') {
    const reason = event.reason as any;
    if (reason?.response) {
      errorContext.apiError = {
        status: reason.response?.status,
        statusText: reason.response?.statusText,
        url: reason.response?.url || reason.config?.url,
      };
    }
  }

  logErrorToServer(error, {
    severity: 'error',
    context: errorContext,
  });
  captureException(error, { extra: errorContext });

  if (import.meta.env.DEV) {
    console.error('Unhandled Promise Rejection:', event.reason);
  }
});

// 2. 捕捉全域 JavaScript 執行錯誤
window.addEventListener('error', event => {
  const error =
    event.error instanceof Error
      ? event.error
      : new Error(event.message || 'Unknown error');

  const errorContext = {
    type: 'window_onerror',
    source: `${event.filename}:${event.lineno}:${event.colno}`,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
    timestamp: new Date().toISOString(),
  };
  logErrorToServer(error, { severity: 'error', context: errorContext });
  captureException(error, { extra: errorContext });

  if (import.meta.env.DEV) {
    console.error('Global Error:', error);
  }

  // 不阻止默認錯誤處理（讓瀏覽器也顯示錯誤）
  return false;
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <CartProvider>
      <Router />
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 3000,
          style: {
            background: '#363636',
            color: '#fff',
          },
          success: {
            duration: 3000,
            style: {
              background: '#10B981',
            },
          },
          error: {
            duration: 3000,
            style: {
              background: '#EF4444',
            },
          },
        }}
      />
    </CartProvider>
  </React.StrictMode>
);
